import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { CRSelectorConstants } from "../../bpm/config/Componentes/CRSelectorConstants";
import { BasicButton } from "../../theme/Component/BasicButton";
import { PayrollEntitySelect } from "../../admin/CreditPotfolio/PayrollEntity/PayRollEntitySelect";
import { PrintJson } from "../../theme/Component/PrintJson";


interface addCondition {
    PayrollType: any;
    renderPayroll: string;
}

interface Props {
    jsonProps: string;
    onChange: Function;
}

export const ListPropsTypePayroll = ({ jsonProps, onChange }: Props) => {

    const [format, setFortmat] = useState<Partial<addCondition>>({});
    const [lista, setLista] = useState([]);

    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {
        try {
            if (jsonProps && jsonProps.trim() !== "") {
                const parsed = JSON.parse(jsonProps);
                if (Array.isArray(parsed)) {
                    setLista(parsed);
                } else {
                    toast.error("El formato de jsonProps no es una lista válida.");
                    setLista([]);
                }
            } else {
                setLista([]);
            }
        } catch (error) {
            toast.error("Error al parsear jsonProps.");
            setLista([]);
        }
    };


    const create = () => {
        if (!format.PayrollType) {
            toast.error("Debe seleccionar Caja Nominadora valida");
            return;
        }

        const updatedTypePerson = format;
        setLista([...lista, updatedTypePerson]);

        setFortmat({
            renderPayroll: "",
            PayrollType: "",
        });
    };


    const deleteItem = (index: number) => {
        const nuevaLista = lista.filter((_, i) => i !== index);
        setLista(nuevaLista);
    };

    useEffect(() => {
        if (onChange) {
            onChange(JSON.stringify(lista))
        }
    }, [lista])

    return (
        <div className="row">
            <div className="col-md-12 mb-3">
                <div className="row">
                    <div className="col-md-5">
                        <PayrollEntitySelect
                            idSelector={format.PayrollType}
                            label="Caja Nominadora"
                            returnType="Object"
                            onChange={(e: any) => { setFortmat({ ...format, PayrollType: e.IDPayrollEntity, renderPayroll: e.Name }); console.log(e) }}
                        />
                    </div>

                    <div className="col-md-2 d-flex align-items-end">
                        <BasicButton eventClick={create} icon="ri-file-add-line">Agregar</BasicButton>
                    </div>
                </div>
            </div>

            <div className="col-md-12">
                <table className="table table-bordered table-hover">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Caja Nominadora</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {lista.map((item, index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{item.renderPayroll}</td>
                                <td>
                                    <BasicButton
                                        eventClick={() => deleteItem(index)}
                                        icon="ri-delete-bin-line"
                                        children="Eliminar"
                                    />
                                </td>
                            </tr>
                        ))}
                        {lista.length === 0 && (
                            <tr>
                                <td colSpan={6} className="text-center">No hay caracterizaciones agregadas</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}